// import React, { Fragment, useEffect, useState } from 'react';
// import './AllProducts.css';
// import { useSelector, useDispatch } from 'react-redux';
// import { getProducts, getProductsByCategory, getProductsByCol, getProductsByCollection, getProductsBySearch, getProductsBySlug } from '../../../redux/actions/productActions';
// import { getAllCollections } from "../../../redux/actions/collectionActions";
// import Loader from '../.././layout/Loader/Loader';
// import ProductCards from '../../../components/ProductCards';
// import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
// import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
// import { Button, Dialog, DialogContent } from '@mui/material';
// import ProductFilter from '../../layout/ProductFilter';
// import ProductSort from '../../layout/ProductSort';
// import ProductByColCards from '../ProductByColCards';
// import ProductsBySearchCard from '../../ProductBysearchCard';
// import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
// import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
// import { makeStyles } from '@material-ui/core/styles';

// const useStyles = makeStyles({
//   dialogContent: {
//     // Add your custom CSS styles here
//     // For example:
//     padding: 'none',
//   },
//   dialogPaper: {
//     borderRadius: '2px',
//     width: '90vw',
//     height: '90vh',
//     maxWidth: '900px !important',
//     maxHeight: '550px !important',
//     transform: 'scale(1)',
//     transition: 'transform 0.5s ease-in-out',
//     boxShadow: 'none',
    
//   },
//   dialogPaperOpen: {
//     transform: 'scale(1.1)',
    
//   },
//   dialogContent: {
//     padding: '4px',
//   },
// });

// function AllProducts() {
//   const classes = useStyles();
//   const { products, loading,} = useSelector(
//     (state) => state.products
//   );
//   const productsByCol = useSelector((state) => state.productsByCol);
//   const { searchedProducts, productsCount, } = useSelector(
//     (state) => state.searchedProducts
//   );
//   const collectionBannerUrl = productsByCol.productsByCol.colBanner;
//   const [selectedFilters, setSelectedFilters] = useState([]);
//   const { collectionSlug, categorySlug } = useParams();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
// console.log(searchedProducts);
//   const [sortDropdown, setSortDropdown] = useState(false);
//   const [selectedOption, setSelectedOption] = useState(
//     localStorage.getItem("selectedOption") || "Popularity"
//   );

//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [openDialog, setOpenDialog] = useState(false);

// // Function to handle opening the dialog
// const handleOpenDialog = (product) => {
//   setSelectedProduct(product);
//   setOpenDialog(true);
// };

// // Function to handle closing the dialog
// const handleCloseDialog = () => {
//   setOpenDialog(false);
// };

//   const onMouseEnter = (e) => {
//     e.preventDefault();

//     if (window.innerWidth < 600) {
//       setSortDropdown(false);
//     } else {
//       setSortDropdown(true);
//     }
//   };

//   const onMouseLeave = (e) => {
//     e.preventDefault();

//     if (window.innerWidth < 600) {
//       setSortDropdown(false);
//     } else {
//       setSortDropdown(false);
//     }
//   };

//   useEffect(() => {
//     dispatch(getAllCollections());
//   }, [dispatch]);

//   const { search } = useLocation();

//   console.log(search);

//   useEffect(() => {
//     const searchParams = new URLSearchParams(search);
//     const searchQuery = searchParams.get("q");

//     if (searchQuery) {
//       dispatch(getProductsBySearch(searchQuery));
//     } else if (collectionSlug) {
//       dispatch(getProductsByCollection(collectionSlug));
//     } else if (categorySlug) {
//       dispatch(getProductsByCategory(categorySlug));
//     } else {
//       dispatch(getProducts());
//     }
//   }, [dispatch, collectionSlug, categorySlug, search]);

//   const numOfProducts = (products || [products]).length;

//   const [searchParams] = useSearchParams();
//   const location = useLocation();

//   const isCollectionPage = location.pathname.includes('/collections/');
//   // useEffect(() => {
//   //   window.scrollTo({
//   //     top: 0,
//   //   });
//   // }, [selectedFilters, selectedOption]);

//   // useEffect(() => {
//   //   if (selectedOption !== localStorage.getItem("selectedOption")) {
//   //     let url = `${window.location.pathname}?`;
//   //     const searchParams = new URLSearchParams(window.location.search);
//   //     for (const [key, value] of searchParams.entries()) {
//   //       if (key !== "sort") {
//   //         url += `${key}=${value}&`;
//   //       }
//   //     }
//   //     url += `sort=${selectedOption}`;
//   //     navigate(url);
//   //   }
//   // }, [selectedOption, navigate]);

  

//   useEffect(() => {
//     const searchParams = new URLSearchParams(window.location.search);
//   }, []);

//   let productCards;
// if (collectionSlug) {
//   productCards = productsByCol.productsByCol.products && productsByCol.productsByCol.products.map((product) => (
//     <ProductByColCards key={product._id} product={product} handleOpenDialog={handleOpenDialog} />
//   ));
// } else if (searchedProducts) {
//   productCards = searchedProducts.map((product) => (
//     <ProductsBySearchCard key={product._id} product={product} handleOpenDialog={handleOpenDialog} />
//   ));
// } else {
//   productCards = products && products.map((product) => (
//     <ProductCards key={product._id} product={product} handleOpenDialog={handleOpenDialog} />
//   ));
// }
//   return (
//     <Fragment>
//       {isCollectionPage && collectionBannerUrl && (
//         <div className='prd_pg_banr_d prd_pg_banr_m'>
//           <img src={collectionBannerUrl} alt="collection banner" className='prd_pg_banr_d_img prd_pg_banr_m_img'/>
//         </div>
//       )}
//       {loading ? (
//       <h1 style={{marginTop: '200px'}}>Loading.....</h1>
//       ) : (
//         <Fragment>
//           <div className='all_prod_main_wrap'>
//             <div className='products_p_sub_header'>
//               <div>
//                 <div style={{ fontSize: '0.85rem', textTransform: 'capitalize', color: 'gray' }}>Home {location.pathname} / <span>{searchParams.get('q')}</span></div>
//                 <span style={{ fontSize: '0.9rem', fontWeight: '600', textTransform: 'capitalize' }}>{searchParams.get('q')} - </span><span style={{ color: 'gray', fontSize: '0.9rem' }}>{numOfProducts} items</span>
//               </div>
//               {/* <div
//                 onMouseEnter={onMouseEnter}
//                 onMouseLeave={onMouseLeave}
//                 className='sort_btn'>
//                 Sort by: <span style={{ fontWeight: '400', fontSize: '0.9rem' }}>Recommended<KeyboardArrowDownRoundedIcon /></span>
//                 <div className='product_sort_bx'>
//                   {sortDropdown && <ProductSort selectedOption={selectedOption} setSelectedOption={setSelectedOption} sortDropdown={sortDropdown} />}
//                 </div>
//               </div> */}
//             </div>
//             <div className='prod_flt_grid prod_flt_grid_m'>
//               {/* <div className='p_filter_box_d p_filter_box_m'>
//                 <ProductFilter onFilterChange={setSelectedFilters} />
//               </div> */}
//               <div className='All_products'>
//                   {collectionSlug && productCards}
//                   {!collectionSlug && !searchedProducts && productCards}
//                   {!collectionSlug && searchedProducts && (
                    
//                       <div className='All_products'>
//                         {productCards}
//                       </div>
                   
//                   )}
//                 </div>
              
//             </div>
//           </div>
//           <Dialog
//   open={openDialog}
//   onClose={handleCloseDialog}
//   classes={{
//     paper: classes.dialogPaper,
//   }}
//   BackdropProps={{
//     style: {
//       backgroundColor: 'rgba(98,60,33,0.4)',
//       backdropFilter: 'blur(8px)',
//     },
//   }}
// >
//   <CloseRoundedIcon
//     style={{
//       position: 'absolute',
//       right: '10px',
//       top: '10px',
//       fontSize: 'medium',
//       cursor: 'pointer',
//     }}
//     onClick={handleCloseDialog}
//   />
//   <DialogContent className={classes.dialogContent}>
//     {/* Render the product details in the dialog */}
//     {selectedProduct && (
//       <div className="Quickview_popUp_wrapper">
//         <div className="popUp_img_upr_wrapper">
//           <Link className="Quickview_popUp_img_container" to={`/product/${selectedProduct.slug}`}>
//             <img src="../../img/myntrasample.jpg" alt={selectedProduct.name} />
//           </Link>
//         </div>
//         <div className="Quickview_popUp_prod_info_container">
//           <div className="popUp_prod_info_wrapper">
//             <p className="popUp_prod_name">{selectedProduct.name}</p>
//             <p className="popUp_price">₹{selectedProduct.price}</p>
//           </div>
//           <button className="popUp_view_details_btn">
//             View Details <ArrowForwardRoundedIcon />
//           </button>
//         </div>
//       </div>
//     )}
//   </DialogContent>
// </Dialog>
//         </Fragment>
//       )}
//     </Fragment>
//   );
// }
//   export default AllProducts

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetAllProductsQuery } from '../../../redux/APIs/productApi';
import { setAllProducts } from '../../../redux/Slices/productSlice';
import ProductCards from '../../ProductCards';
import SingleProductSwipe from './ImageSlider/SingleProductSwipe';

function AllProducts() {
  const dispatch = useDispatch();
  const [isSwipeView, setIsSwipeView] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const searchedProducts = useSelector((state) => state.product.searchedProducts);
  const { data: allProducts, isLoading: loadingProducts } = useGetAllProductsQuery();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleSwipeUp = () => {
    if (currentIndex < allProducts.products.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleSwipeDown = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientY);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.touches[0].clientY);
  };

  const handleTouchEnd = () => {
    if (touchStart && touchEnd) {
      const difference = touchStart - touchEnd;
      const threshold = 50;
      if (difference > threshold) {
        handleSwipeUp();
      } else if (difference < -threshold) {
        handleSwipeDown();
      }
    }
    setTouchStart(null);
    setTouchEnd(null);
  };

  useEffect(() => {
    if (allProducts) {
      dispatch(setAllProducts(allProducts.products));
    }
  }, [allProducts, dispatch]);

  useEffect(() => {
    if (isSwipeView) {
      setShowInfo(true);
      const timeout = setTimeout(() => {
        setShowInfo(false);
      }, 10000);
      return () => clearTimeout(timeout);
    }
  }, [isSwipeView]);

  return (
    <div
      className="relative w-full min-h-screen flex flex-col items-center  max-sm:px-1 sm:px-4 py-10 overflow-hidden
                 bg-gradient-to-br from-pink-100 via-blue-100 to-purple-100" // ✅ Pastel Background
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {/* Swipe View Toggle */}
      <div className="w-full max-sm:flex sm:hidden justify-end mt-[18px]">
        <div className="flex items-center gap-2">
          <span className="text-xs">Swipe View</span>
          <button
            className={`w-10 h-5 rounded-full shadow-sm relative flex items-center transition-colors duration-300 ${
              isSwipeView ? 'bg-blue-500' : 'bg-pink-100'
            }`}
            onClick={() => setIsSwipeView((prev) => !prev)}
          >
            <div
              className={`w-5 h-5 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
                isSwipeView ? 'translate-x-[1.2rem]' : 'translate-x-0'
              }`}
            ></div>
          </button>
        </div>
      </div>

      {/* Product Swipe View */}
      {allProducts?.products && isSwipeView && (
        <SingleProductSwipe
          product={allProducts.products[currentIndex]}
          key={allProducts.products[currentIndex].id}
          loading={loadingProducts}
          onSwipeUp={handleSwipeUp}
          onSwipeDown={handleSwipeDown}
        />
      )}

      {/* Product Grid View */}
      {!isSwipeView && (
        // <div className="flex justify-center w-full">
        <div className="grid grid-cols-2 sm:grid-cols-3 max-sm:gap-2 sm:gap-6 w-full max-w-6xl mx-auto mt-10 place-items-center">
          {allProducts?.products?.map((product) => (
            <ProductCards product={product} key={product.id} loading={loadingProducts} />
          ))}
        </div>

      )}
    </div>
  );
}

export default AllProducts;
